import {Region} from "platformed-client/types";
import {platformedClient} from ".";

export async function listRegions() {
  return await platformedClient.internalRequest("get", "/api/portal_discovery/regions", {});
}

export async function listPortals(region: Region) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/portal_discovery/portals", {
    path: {region},
  });
}
